import { ListItem } from '@uplift/types';
import { restClient } from '../client';

export type GetEthnicitiesResponse = {
  data: ListItem[];
};

export const getEthnicities = async () => {
  return await restClient.request<GetEthnicitiesResponse>('/api/v1/ethnicities');
};
